class AlertCountCircle {
  constructor() {
    this.template = AlertCountCircle.template
    this.scope = {count: '='}
  }
}

AlertCountCircle.template = `
  <div>{{ count }}</div>
`

export default AlertCountCircle
